import {useContext} from 'react'
import {GlobalContext} from '../context/GlobalState'
import { Link } from 'react-router-dom'
import { ListGroup, ListGroupItem, Button } from 'reactstrap'


const UserList = () => {
    const {users, removeUser} = useContext(GlobalContext)   //users here must tally with the obj key here <GlobalContext.Provider value={{users: state.users}}> 
    
    return (
        <ListGroup className='mt-4'>
            {users.length > 0 ? (
                <>    
                {users.map(user => (
                    <ListGroupItem className='d-flex' key={user.id}>
                    <strong  style={{marginRight: '15rem'}}>{user.name}</strong>
                    <div className='ml auto'>
                        <Link className='btn btn-warning mr-1' to={`/Edit/${user.id}`}>Edit</Link>
                        <Button onClick={() => removeUser(user.id)} color='info'>Delete</Button>
                    </div>
                    </ListGroupItem>
                    )) }
                </>
            ) : (
                <h5 className="text-center">No User</h5>
            )}
        </ListGroup>
    )
}

export default UserList
